import { createStatusCellRenderer } from '@fortem-monorepo/react-ag'
import { Spinner } from '@fortem-monorepo/react-ui'
import { BatchExecutor } from '@fortem-monorepo/web-sdk'

export const BatchExecutorStatusCellRenderer = createStatusCellRenderer<BatchExecutor.ReportItem>({
  success: {
    label: 'Completed',
    renderIf: ({ data }) => {
      return !data.crashed && !!data.completiontimestamp
    },
  },
  error: {
    label: 'Crashed',
    renderIf: ({ data }) => {
      return !!data.crashed
    },
  },
  inProgress: {
    label: 'Running',
    icon: <Spinner className={'size-4'} />,
    renderIf: ({ data }) => {
      return !data.crashed && !!!data.completiontimestamp
    },
  },
})
